import React, { useEffect, useRef, useState } from "react";
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useLocation, useNavigate } from "react-router-dom";
import { Password } from "primereact/password";
import paystub from "../../../src/image/paystub-bg.jpg";
import contactUs from "../../../src/image/contact-us-bg.jpg";
import heroBg from "../../../src/image/term-bg.png";
import { InputTextarea } from "primereact/inputtextarea";
import { postAllData } from "../../service/ProductService";
import { CONTACT_US } from "../../config/ApiConstant";
import { Toast } from "primereact/toast";
import { ContactUSValidation } from "../../config/Validate";
import Footer from "../../components/Footer/Footer";

export default function AboutUs() {
  document.title = "Nexawage Payroll| About Us";
  const navigate = useNavigate();
  const toast = useRef<any>(null);
  const location = useLocation();

  // hamberger icon togggle
  const [menuOpen, setMenuOpen] = useState(false);
  const [errors, setErrors] = useState<any>({});

  // state to store contact us form data
  const [formData, setFormData] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(false);

  // onchange functiion
  const handleChange = (e: any, name: string) => {
    let val;
    val = e.target.value;
    setFormData({ ...formData, [name]: val });
    setErrors({ ...errors, [name]: "" });
  };

  // contact us form submit api
  const submitForm = async () => {
    try {
      const { isError, errors } = ContactUSValidation(formData);
      setErrors(errors);
      if (isError) return;
      setLoading(true);

      const response = await postAllData(CONTACT_US, formData);

      if (response) {
        setFormData({});
        setLoading(false);
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: response?.message,
        });
      }
    } catch (error: any) {
      toast.current?.show({
        serverity: "error",
        summary: "error",
        detail: error?.response?.message?.error,
      });
      setLoading(false);
    }
  };

  return (
    <>
      <Toast ref={toast} />
      <div className="aboutus-page">
        {/* header */}
        <div className="header">
          <div className="header-container">
            <div className="logo" onClick={() => navigate("/")}>
              <img
                // src="\assets\images\Nexawage_new_logo.png"
                src="https://nexawage.com/assets/images/Nexawage_new_logo.png"
                alt="NexaWage Logo"
              />
              <h2>NexaWage Payroll</h2>
            </div>

            <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
              <a
                href="#about-us"
                onClick={(e) => {
                  e.preventDefault();
                  document
                    .querySelector("#about-us")
                    ?.scrollIntoView({ behavior: "smooth" });
                  setMenuOpen(false);
                }}
              >
                About Us
              </a>

              <a
                href="#services"
                onClick={(e) => {
                  e.preventDefault();
                  document
                    .querySelector("#services")
                    ?.scrollIntoView({ behavior: "smooth" });
                  setMenuOpen(false);
                }}
              >
                Services
              </a>

              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  document
                    .querySelector("#contact")
                    ?.scrollIntoView({ behavior: "smooth" });
                  setMenuOpen(false);
                }}
              >
                Contact Us
              </a>
            </nav>

            <div className="header-actions">
              <Button
                label="Login"
                className="desktop-login"
                onClick={() => navigate("/login")}
              />

              <Button
                className="hamburger"
                onClick={() => setMenuOpen(!menuOpen)}
              >
                <i className={`pi ${menuOpen ? "pi-times" : "pi-bars"}`}></i>
              </Button>
            </div>
          </div>
        </div>

        {/* Hero Banner */}
        <section
          className="hero-section"
          style={{
            backgroundImage: `url(${heroBg})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div className="hero-overlay">
            <div className="hero-content">
              <h1>NexaWage Payroll</h1>
              <h4>Payroll Made Simple for Canadian Businesses</h4>
              <p>
                Automated paystubs, payroll scheduling, and CRA compliance —
                designed for SMEs.
              </p>
              <Button
                label="Login"
                className="p-button-rounded p-button-lg hero-login"
                // style={{
                //   padding: "10px 40px",
                //   borderRadius: "10px",
                //   marginTop: "30px",
                //   background: "#fff",
                //   color: "#111",
                // }}
                onClick={() => navigate("/login")}
              />
            </div>
          </div>
        </section>

        {/* Company Intro */}
        <div id="about-us">
          <div className="company-intro wrapper">
            <div className="container company-content">
              <div className="left">
                <div className="intro-text">
                  <h2>Who We Are</h2>
                  <p>
                    NexaWage Payroll is a modern payroll technology platform
                    built to help Canadian businesses simplify salary management
                    and compliance. Our mission is to empower small and
                    medium-sized businesses with automated payroll solutions
                    that:
                  </p>
                  <ul>
                    <li className="ml-4">
                      <p className="mb-0">Reduce errors and save time</p>
                    </li>
                    <li className="ml-4">
                      <p className="mb-0">
                        Ensure CRA compliance with accurate CPP, EI, and tax
                        deductions
                      </p>
                    </li>
                    <li className="ml-4">
                      <p className="mb-0">
                        Provide secure and reliable paystub generation & PD7A
                        reporting
                      </p>
                    </li>
                  </ul>
                  <p className="mt-3">
                    Our mission is to empower small and medium-sized businesses
                    with automated payroll solutions that reduce errors, save
                    time, and ensure compliance with CRA regulations.
                  </p>
                  <p>
                    With a team of experienced developers and compliance
                    specialists, we provide powerful tools for paystub
                    generation, PD7A reporting, and payroll scheduling.
                  </p>
                </div>
              </div>
              <div className="right">
                <img src="\assets\images\paystub-about.png" />
              </div>
            </div>
          </div>
        </div>

        {/* Why Choose Us */}
        <section id="services">
          <div className="choose-us wrapper">
            <h2 className="divider-text">Why Choose NexaWage Payroll?</h2>

            <div className="why-grid">
              <Card className="why-card shadow-2">
                <i className="pi pi-cloud why-icon"></i>
                <h3>Secure Cloud Platform</h3>
                <p>
                  Access payroll anytime with enterprise-grade encryption & data
                  security.
                </p>
              </Card>
              <Card className="why-card shadow-2">
                <i className="pi pi-check-circle why-icon"></i>
                <h3>CRA-Compliant</h3>
                <p>
                  Automatic CPP, EI, and tax calculations to stay fully
                  compliant.
                </p>
              </Card>
              <Card className="why-card shadow-2">
                <i className="pi pi-dollar why-icon"></i>
                <h3>Affordable & Scalable</h3>
                <p>
                  Flexible pricing designed for startups and growing
                  enterprises.
                </p>
              </Card>
            </div>
          </div>
        </section>

        {/* Contact Us */}
        <section id="contact">
          <div className="contact-us wrapper">
            <div className="contactus-contain">
              <div className="right">
                <img src={contactUs} />
              </div>
              <div className="left">
                <div className="contact-container">
                  <div className="contact-card shadow-2">
                    <h2 className="divider-text">Contact Us</h2>
                    <div className="contact-form">
                      <div className="p-field">
                        <label htmlFor="name">Name</label>
                        <InputText
                          id="name"
                          type="text"
                          value={formData?.name || ""}
                          onChange={(e) => handleChange(e, "name")}
                          placeholder="Enter your name"
                          className="w-full"
                        />
                        <small className="p-invalid-txt">
                          {errors["name"]}
                        </small>
                      </div>

                      <div className="p-field">
                        <label htmlFor="email">Email</label>
                        <InputText
                          id="email"
                          type="email"
                          value={formData?.email || ""}
                          onChange={(e) => handleChange(e, "email")}
                          placeholder="Enter your email"
                          className="w-full"
                        />
                        <small className="p-invalid-txt">
                          {errors["email"]}
                        </small>
                      </div>

                      <div className="p-field">
                        <label htmlFor="subject">Phone Number</label>
                        <InputText
                          id="mobile"
                          type="mobile"
                          value={formData?.mobile || ""}
                          onChange={(e) => handleChange(e, "mobile")}
                          placeholder="Enter Phone Number"
                          className="w-full"
                        />
                        <small className="p-invalid-txt">
                          {errors["mobile"]}
                        </small>
                      </div>

                      <div className="p-field">
                        <label htmlFor="message">Message</label>
                        <InputTextarea
                          id="message"
                          rows={2}
                          value={formData?.message || ""}
                          onChange={(e) => handleChange(e, "message")}
                          placeholder="Write your message"
                          className="p-inputtext w-full"
                        />
                        <small className="p-invalid-txt">
                          {errors["message"]}
                        </small>
                      </div>

                      <Button
                        label="Send Message"
                        className="common-primary-button"
                        loading={loading}
                        // style={{ background: "#41486b", color: "#fff" }}
                        onClick={submitForm}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Footer */}
        <Footer />
      </div>
    </>
  );
}
